import { render, staticRenderFns } from "./historyAssign.vue?vue&type=template&id=f941bc7a&scoped=true"
import script from "./historyAssign.vue?vue&type=script&lang=js"
export * from "./historyAssign.vue?vue&type=script&lang=js"
import style0 from "./historyAssign.vue?vue&type=style&index=0&id=f941bc7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f941bc7a",
  null
  
)

export default component.exports